import { useCallback } from "react";
import { SERVER_HOST } from "../../../constants/config";

const BaseAPIUrl = SERVER_HOST;

const useEKYCService = () => {

  const startEkyc = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };

      return fetch(BaseAPIUrl + "/ekyc/start", config).then((response) => response.json());
    },
    []
  );

  const getValidationRecordFromToken = useCallback(
    async (token) => {
      const config = {
        method: "get",
      };

      return fetch(`${BaseAPIUrl}/ekycv3?token=${token}`, config).then((response) => response.json());
    },
    []
  );

  const getVerificationCertificate = useCallback(
    async (clientID, refID) => {
      const config = {
        method: "get",
      };

      return fetch(`${BaseAPIUrl}/verification-certificate/${clientID}/${refID}`, config).then((response) => response.json());
    },
    []
  );


  return {
    startEkyc,
    getValidationRecordFromToken,
    getVerificationCertificate,
  };
};

export { useEKYCService };
